import React from 'react'
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from '@/components/ui/card'

// Type for a single weather entry
export interface WeatherCardData {
  title: string
  temperature: string
  sunshineChance: string
  frostLevel: string
  icon?: string // Emoji or image path
}

interface WeatherCardProps {
  data: WeatherCardData
}

// WeatherCard component for displaying a single weather info card
const WeatherCard: React.FC<WeatherCardProps> = ({ data }) => {
  return (
    <Card className="flex flex-col items-center bg-neutral-50 min-w-[220px] max-w-[260px] mx-auto">
      <CardHeader className="flex flex-col items-center justify-center pb-2">
        <span className="text-5xl mb-2">{data.icon || '☀️'}</span>
        <CardTitle className="text-lg text-gray-800 mb-1">{data.title}</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col items-start gap-1 px-4 pb-4">
        <span className="text-base text-gray-700">Temperatur: {data.temperature}</span>
        <span className="text-base text-gray-700">Schönwetterchance: {data.sunshineChance}</span>
        <span className="text-base text-gray-700">Frostgrenze: {data.frostLevel}</span>
      </CardContent>
    </Card>
  )
}

export default WeatherCard
